export const loginPageTranslationsEn = {
  heroAlt: 'CHiME agent hero image',
  heroTitle: 'CHiME agent',
  heroDescription:
    'Streamline your workflow with AI-extracted data from scanned forms. CHiME agent enables fast, accurate review and seamless transition from document to order.',
  loginButtonLabel: 'Login as J&J Employee',
  loginButtonArrow: '→',
};
